import { Hooks } from 'providers';
import { Matrix } from 'providers/Matrix';
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { HIT_CHANGE_MATRIX } from 'redux/actions/matrix';

function ConflictData() {
  const dispatch = new useDispatch();
  const { modalConflict, setModalConflict } = useContext(Matrix);
  const { modal, setModal } = useContext(Hooks);
  return (
    <div
      className={`modal fade rModal ${modalConflict && 'show'}`}
      id="conflictModal"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      style={{
        width: 'fit-content',
        display: modal ? 'block !important' : 'none !important',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        height: 'fit-content',
      }}
    >
      <div className="modal-dialog modal-md" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">Conflicting Data</h4>
          </div>
          <div className="modal-body m-2">
            <div className="rConflictBody">
              <div className="rConflictList mb-3">
                <div className="col-6">
                  <span>
                    Tania Handoko
                    <br />
                    <b>1122545487</b>
                  </span>
                </div>
                <div className="col-3">
                  <button
                    className="btn btn-pill btnRLv1 badge w-100"
                    disabled=""
                  >
                    A
                  </button>
                </div>
                <div className="col-3">
                  <span>
                    9 Oktober 2021
                    <br />
                    <b>17:20 PM</b>
                  </span>
                </div>
              </div>
              <div className="rConflictList mb-3">
                <div className="col-6">
                  <span>
                    Eskavia Rozi
                    <br />
                    <b>1902290027</b>
                  </span>
                </div>
                <div className="col-3">
                  <button
                    className="btn btn-pill btnRLv1 badge w-100"
                    disabled=""
                  >
                    A
                  </button>
                </div>
                <div className="col-3">
                  <span>
                    9 Oktober 2021
                    <br />
                    <b>17:20 PM</b>
                  </span>
                </div>
              </div>
              <div className="rConflictList mb-3">
                <div className="col-6">
                  <span>
                    Hardianti Devi
                    <br />
                    <b>1902290028</b>
                  </span>
                </div>
                <div className="col-3">
                  <button
                    className="btn btn-pill btnRLv1 badge w-100"
                    disabled=""
                  >
                    A
                  </button>
                </div>
                <div className="col-3">
                  <span>
                    9 Oktober 2021
                    <br />
                    <b>17:20 PM</b>
                  </span>
                </div>
              </div>
              <div className="rConflictList mb-3">
                <div className="col-6">
                  <span>
                    Giarini
                    <br />
                    <b>1902290028</b>
                  </span>
                </div>
                <div className="col-3">
                  <button
                    className="btn btn-pill btnRLv1 badge w-100"
                    disabled=""
                  >
                    A
                  </button>
                </div>
                <div className="col-3">
                  <span>
                    9 Oktober 2021
                    <br />
                    <b>17:20 PM</b>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer m-2">
            <form>
              <select className="form-control">
                <option selected="">--Choose ARCESI--</option>
                <option>A</option>
                <option>R</option>
                <option>C</option>
                <option>E</option>
                <option>S</option>
                <option>I</option>
              </select>
            </form>
            <button
              type="submit"
              className="btn btn-md btnRacc badge"
              onClick={() => {
                dispatch({
                  type: HIT_CHANGE_MATRIX,
                  payload: {},
                });
              }}
            >
              Resolve
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConflictData;
